"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _hopsSdkJs = require("@hps/hops-sdk-js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _SeatReservationKeyLabels = require("./SeatReservationKeyLabels.js");
var _SeatReservationSpace = _interopRequireDefault(require("./SeatReservationSpace.js"));
var _String = _interopRequireDefault(require("../Components/String.js"));
var _SeatReservationKeyModule = _interopRequireDefault(require("./SeatReservationKey.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SeatReservationKey = /*#__PURE__*/(0, _react.memo)(props => {
  const {
    seatPlans
  } = props;

  /**
   * Spaces to show in the key
   */
  const keySpaces = (0, _react.useMemo)(() => {
    const keySpaces = [];
    const shapesAddedToKey = [];
    const spaces = seatPlans.map(sp => sp?.Spaces || []).flat();
    for (const space of spaces) {
      const shape = space.Shape;
      if (shape !== _hopsSdkJs.SeatPlanSpaceShapes.Empty) {
        if (!shapesAddedToKey.includes(shape)) {
          shapesAddedToKey.push(shape);
          keySpaces.push({
            ...space,
            Bulkhead0: false,
            // Remove the partitions
            Bulkhead90: false,
            Bulkhead180: false,
            Bulkhead270: false,
            Label: "X" // Remove the seat number
          });
        }
      }
    }
    return keySpaces;
  }, [seatPlans]);

  /**
   * A demonstration divider
   */
  const demoDivider = {
    ...keySpaces[0],
    // Use any space
    Bulkhead180: true,
    // Bulkhead closest to the key label
    Label: null,
    // Remove the seat number
    Shape: 4 // Empty shape
  };

  /**
   * Render!
   */
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _SeatReservationKeyModule.default.key,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _SeatReservationKeyModule.default.keySpace,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SeatReservationSpace.default, {
          selected: true,
          selectable: false,
          space: keySpaces[0]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
          str: "Your selection",
          noFlex: true,
          variant: "body2"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _SeatReservationKeyModule.default.keySpace,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SeatReservationSpace.default, {
          bookedWithinOrder: true,
          selectable: false,
          space: keySpaces[0]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
          str: "Your other seats in this order",
          noFlex: true,
          variant: "body2"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _SeatReservationKeyModule.default.keySpace,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SeatReservationSpace.default, {
          booked: true,
          selectable: false,
          space: keySpaces[0]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
          str: "Reserved",
          noFlex: true,
          variant: "body2"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _SeatReservationKeyModule.default.keySpace,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SeatReservationSpace.default, {
          excluded: true,
          selectable: false,
          space: keySpaces[0]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
          str: "Unavailable",
          noFlex: true,
          variant: "body2"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _SeatReservationKeyModule.default.key,
      children: [keySpaces.map((keySpace, key) => {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _SeatReservationKeyModule.default.keySpace,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SeatReservationSpace.default, {
            selectable: false,
            space: keySpace
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
            str: `= ${(0, _SeatReservationKeyLabels.getSeatPlanSpaceShapeLabel)(keySpace.Shape)}`,
            noFlex: true,
            variant: "body2"
          })]
        }, key);
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _SeatReservationKeyModule.default.keySpace,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SeatReservationSpace.default, {
          selectable: false,
          space: demoDivider
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
          str: " = Internal Partition/Bulkhead",
          noFlex: true,
          variant: "body2"
        })]
      })]
    })]
  });
});
SeatReservationKey.propTypes = {
  seatPlans: _propTypes.default.arrayOf(_propTypes.default.object)
};
SeatReservationKey.defaultProps = {
  seatPlans: []
};
var _default = exports.default = SeatReservationKey;